import { FormControl, FormControlLabel, Radio, RadioGroup } from "@mui/material";
import { useHouseContext } from "../../HouseContext";
import { useAuthContext } from "../../Auth";
import { House } from "../../ostertalertypes";
import { useStepperContext } from "./StepperContext";


export const StepHouse: React.FC = (props) => {
    const houseCtx = useHouseContext();
    const authCtx = useAuthContext();
    const stepperCtx = useStepperContext();

    const handleChange = (newLocation: House) => {
      stepperCtx.updateSelectedHouse(newLocation);
    };

    // Filter houses: if admin, only show houses the admin has access to; if not admin, show all
    const visibleHouses = authCtx.isAdmin()
      ? Array.from(houseCtx.houses).filter(([houseName, _]) => authCtx.adminHouses.map(h => h.toLowerCase()).includes(houseName.toLowerCase()))
      : Array.from(houseCtx.houses);

    return (
      <FormControl>
        <RadioGroup
          aria-labelledby="demo-radio-buttons-group-label"
          defaultValue={stepperCtx.selectedHouse?.houseName}
          name="radio-buttons-group"
        >
          {visibleHouses.map(([houseName, house]) => {
            return <FormControlLabel key={houseName} value={house.houseName} control={<Radio onChange={handleChange.bind(null, house)} />} label={house.houseName} />
          })}
        </RadioGroup>
      </FormControl>
    );
  };